<template>
  <IcoIdenticon
    v-if="currency && isICOCurrency(currency)"
    :name="currency.name"
    :symbol="currency.symbol"
  />
  <FallbackImage
    v-else
    class="currency-icon"
    :src="currencyIconSrc"
    :fallback-src="placeholderIcon"
    :alt="alt"
  />
</template>

<script lang="ts">
import { publicEnv } from '@/config/runtime'
import './CurrencyIcon.scss'

import { defineComponent, type PropType } from 'vue'
import FallbackImage from '@/components/misc/FallbackImage'
import IcoIdenticon from '@/components/misc/IcoIdenticon'
import { DEFAULT_CURRENCY_ICON_URL } from '@/constants/assets'
import { isICOCurrency } from '@/helpers/assets'
import type { Currency } from '@/types/services/global'

export default defineComponent({
  components: {
    FallbackImage,
    IcoIdenticon,
  },

  props: {
    currency: {
      type: Object as PropType<Currency | null>,
      default: null,
    },
  },

  data() {
    return {
      placeholderIcon: DEFAULT_CURRENCY_ICON_URL,
    }
  },

  computed: {
    alt(): string {
      return this.currency?.name || '-'
    },
    currencyIconSrc(): string {
      const { currency } = this
      if (currency == null || !currency.has_image) {
        return this.placeholderIcon
      } else if (currency.group == 'fiat') {
        return `${publicEnv('VUE_APP_STATIC_FILES_URL')}/${currency.id}.png`
      } else {
        return `${publicEnv('VUE_APP_STATIC_FILES_URL')}/${currency.id}.jpg`
      }
    },
  },

  methods: {
    isICOCurrency,
  },
})
</script>
